/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var propertiesParser = require('properties-parser').parse;

module.exports = propertiesParser;
